module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/top_picture-7b8e620c868f0485f49edfa846ac2210.jpg";